import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import DeviationMediaService from '../../../utils/DeviationMediaService';
import { ResourceType } from '../../../types/resource';
import s from './CommissionCover.scss';
const getCoverImageAttributes = (deviation)=>{
    const coverUrl = DeviationMediaService.getLargestFullview(deviation).src;
    return {
        backgroundImage: `url('${coverUrl}')`
    };
};
export const CommissionCover = ({ deviation  })=>{
    const isMobile = useContext(MobileContext);
    if (isMobile || !deviation.coverImage) {
        return null;
    }
    const coverImageStyle = getCoverImageAttributes(deviation.coverImage);
    return /*#__PURE__*/ React.createElement("div", {
        className: s['cover-image'],
        "data-itemid": deviation.coverImage.deviationId,
        "data-typeid": ResourceType.DEVIATION,
        style: coverImageStyle
    });
};
CommissionCover.displayName = 'CommissionCover';
export default CommissionCover;
